import { SpinResultData } from "@lib/titan2-slingo/dist/api/model/data/SpinResultData";
import { SymbolWinData } from "@lib/titan2-slingo/dist/api/model/data/SymbolWinData";
import { SymbolType } from "@lib/titan2-slingo/dist/api/model/enum/SymbolType";
import { Test } from "@lib/titan2-slingo/dist/game/view/abstract/display/Test";
import { TitanButton } from "@lib/titan2/dist/game/control/TitanButton";
import { Dictionary } from "@lib/titan2/dist/util/collection/Dictionary";
import { FeatureTestData } from "../../../model/data/FeatureTestData";
import { FeatureTransitionEvents } from "../../../controller/FeatureTransitionController";
import { AppData } from "@lib/titan2/dist/game/AppData";
/**
 * GameTest.ts
 */
export class GameTest extends Test {
    constructor(factory, landscapeProperties, portraitProperties) {
        super(factory, landscapeProperties, portraitProperties);
    }
    createButtons() {
        this.testButtons = [];
        super.createButtons();
        this.createFeatureTestButton("Jaspurrs Cups", FeatureTestData.GREEN_FISH, FeatureTransitionEvents.TRANSITION_TO_GREEN_FISH, 5);
        this.createFeatureTestButton("Jaspurrs Cups collect all", FeatureTestData.GREEN_FISH_COLLECT_ALL, FeatureTransitionEvents.TRANSITION_TO_GREEN_FISH, 5);
        this.createFeatureTestButton("MeowLady", FeatureTestData.RED_FISH, FeatureTransitionEvents.TRANSITION_TO_RED_FISH, 7);
        this.createFeatureTestButton("MeowLady 2", FeatureTestData.RED_FISH_2, FeatureTransitionEvents.TRANSITION_TO_RED_FISH, 7);
        // this.createFeatureTestButton("red fish error", FeatureTestData.RED_FISH_ERROR, FeatureTransitionEvents.TRANSITION_TO_RED_FISH, 7);
        this.createFeatureTestButton("Hungry Henry", FeatureTestData.PURPLE_FISH, FeatureTransitionEvents.TRANSITION_TO_PURPLE_FISH, 9);
        this.createFeatureTestButton("Tail Totes", FeatureTestData.FISH_FOOD, FeatureTransitionEvents.TRANSITION_TO_FISH_FOOD, 6);
        this.createFeatureTestButton("Tail Totes golden turtle", FeatureTestData.FISH_FOOD_GOLDEN_TURTLE, FeatureTransitionEvents.TRANSITION_TO_FISH_FOOD, 6);
        this.createFeatureTestButton("Tail Totes full house", FeatureTestData.FISH_FOOD_FULL_HOUSE, FeatureTransitionEvents.TRANSITION_TO_FISH_FOOD, 12);
        this.createFeatureTestButton("Clawpawtra", FeatureTestData.GOLD_FISH, FeatureTransitionEvents.TRANSITION_TO_GOLD_FISH, 10);
        this.createFeatureTestButton("Clawpawtra pick collector", FeatureTestData.GOLD_FISH_COLLECTOR, FeatureTransitionEvents.TRANSITION_TO_GOLD_FISH, 10);
        this.createFeatureTestButton("Clawpawtra spin collector", FeatureTestData.GOLD_FISH_SPIN_COLLECTOR, FeatureTransitionEvents.TRANSITION_TO_GOLD_FISH, 10);
        this.createFeatureTestButton("Clawpawtra fh + multiplier collector", FeatureTestData.GOLD_FISH_FH_BLUE_MULTIPLIER_COLLECTION, FeatureTransitionEvents.TRANSITION_TO_GOLD_FISH, 12);
        this.createTestButton("HIDE", this.handleHide);
        this.showButtonsButton = this.createTestButton(`SHOW\n(${AppData.VERSION})`, this.handleShow, false);
        this.handleHide();
    }
    handleShow() {
        this.panel.removeAll();
        this.testButtons.forEach(button => this.panel.addToPanel(button, false));
        this.panel.arrange();
    }
    handleHide() {
        this.panel.removeAll();
        this.panel.addToPanel(this.showButtonsButton, true);
    }
    createTestButton(text, handler, addToArray = true) {
        this.uiProperties.testButtonProperties.movieClipProperties.scale.set(1, 2);
        this.uiProperties.testButtonProperties.textFieldProperties.fontProperties.colour = "black";
        this.uiProperties.testButtonProperties.textFieldProperties.multiline = true;
        this.uiProperties.testButtonProperties.textFieldProperties.size.set(150, 80);
        const button = new TitanButton(this.uiProperties.testButtonProperties);
        button.onClick(handler, this);
        button.setText(text);
        if (addToArray) {
            this.testButtons.push(button);
        }
        this.panel.addToPanel(button, false);
        return button;
    }
    createFeatureTestButton(text, data, kickoff, matchedPatterns) {
        const button = this.createTestButton(text, () => {
            this.model.testFeature(data);
            this.model.setCurrentMatchedPatterns(matchedPatterns);
            this.updateFeatureResult(data.getChanceGame().getTotalWin());
            this.dispatchGame(kickoff);
        });
        return button;
    }
    updateFullHouseResult() {
        this.updateStandardResult();
        let result = this.model.getResultData();
        result.setFullHouse(true);
    }
    updateSymbolWinResult() {
        this.updateStandardResult();
        let result = this.model.getSpinResult();
        if (!result) {
            const winData = new SymbolWinData(undefined);
            winData.setNumberOfSymbols(3);
            winData.setAmount(400);
            winData.setType(SymbolType.JOKER);
            result = new SpinResultData(undefined);
            const symbolWins = new Dictionary();
            symbolWins.setValue(SymbolType.JOKER, winData);
            result.symbolWins = symbolWins;
        }
    }
    updateFeatureResult(value) {
        let result = this.model.getResultData();
        result.reset();
        result.setSlingoWin(value);
        result.setNoWin(false);
        this.model.setTotalWin(value);
    }
    updateStandardResult() {
        this.model.setCurrentMatchedPatterns(5);
        let result = this.model.getResultData();
        result.reset();
        result.setSlingoWin(5);
        result.setNoWin(false);
        this.model.setTotalWin(5);
    }
}
//# sourceMappingURL=GameTest.js.map